<template>
    <div class="mainBox" id="mainBox">
        <div class="mainContent">
            <div class="viewLeft">
                <p id="historyTitle" style="display: none">History Data</p>
                <el-cascader
                    v-model="eventValue"
                    :options="options"
                    @change="handleChange" 
                    clearable
                    size="mini"
                    class="selectArea"
                    placeholder="Please select"></el-cascader>
                <!-- <el-select v-model="eventValue" clearable size="mini" placeholder="Please select" @change="changeArea" class="selectArea">
                    <el-option
                        v-for="item in eventArea"
                        :key="item.value"
                        :label="item.region"
                        :value="item.region"
                    >
                    </el-option>
                </el-select> -->
                <ul class="timeList">
                    <p class="title">TimePicker</p>
                    <li v-for="(item, index) in timeList" :key="index" 
                        @click="changeTime(index)" 
                        :class="current == index ? 'current' : ''"
                    > {{ item.time }} </li>
                </ul>
                <p class="more" id="more" @click="moreData">More</p>
            </div>
            <div class="viewRight"></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'App',
        props: {
            parentMenuItem: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
        data () {
            return {
                eventValue: '',
                eventArea: [],
                current: localStorage.getItem('event-time') || 0,
                timeList: [],
                timeList1: [
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                    {
                        time: '02-21 12:00'
                    },
                ],
                value: '',
                options: [
                    // {
                    //     value: "zhinan",
                    //     label: "指南",
                    // },
                    // {
                    //     value: "zujian",
                    //     label: "组件",
                    //     children: [
                    //         {
                    //         value: "basic",
                    //         label: "Basic",
                    //         children: [
                    //             {
                    //             value: "layout",
                    //             label: "Layout 布局",
                    //             },
                    //             {
                    //             value: "color",
                    //             label: "Color 色彩",
                    //             },
                    //             {
                    //             value: "typography",
                    //             label: "Typography 字体",
                    //             },
                    //             {
                    //             value: "icon",
                    //             label: "Icon 图标",
                    //             },
                    //             {
                    //             value: "button",
                    //             label: "Button 按钮",
                    //             },
                    //         ],
                    //         },
                    //         {
                    //         value: "form",
                    //         label: "Form",
                    //         children: [
                    //             {
                    //             value: "radio",
                    //             label: "Radio 单选框",
                    //             },
                    //             {
                    //             value: "checkbox",
                    //             label: "Checkbox 多选框",
                    //             },
                    //             {
                    //             value: "input",
                    //             label: "Input 输入框",
                    //             },
                    //             {
                    //             value: "input-number",
                    //             label: "InputNumber 计数器",
                    //             },
                    //             {
                    //             value: "select",
                    //             label: "Select 选择器",
                    //             },
                    //             {
                    //             value: "cascader",
                    //             label: "Cascader 级联选择器",
                    //             },
                    //             {
                    //             value: "switch",
                    //             label: "Switch 开关",
                    //             },
                    //             {
                    //             value: "slider",
                    //             label: "Slider 滑块",
                    //             },
                    //             {
                    //             value: "time-picker",
                    //             label: "TimePicker 时间选择器",
                    //             },
                    //             {
                    //             value: "date-picker",
                    //             label: "DatePicker 日期选择器",
                    //             },
                    //             {
                    //             value: "datetime-picker",
                    //             label: "DateTimePicker 日期时间选择器",
                    //             },
                    //             {
                    //             value: "upload",
                    //             label: "Upload 上传",
                    //             },
                    //             {
                    //             value: "rate",
                    //             label: "Rate 评分",
                    //             },
                    //             {
                    //             value: "form",
                    //             label: "Form 表单",
                    //             },
                    //         ],
                    //         },
                    //         {
                    //         value: "data",
                    //         label: "Data",
                    //         children: [
                    //             {
                    //             value: "table",
                    //             label: "Table 表格",
                    //             },
                    //             {
                    //             value: "tag",
                    //             label: "Tag 标签",
                    //             },
                    //             {
                    //             value: "progress",
                    //             label: "Progress 进度条",
                    //             },
                    //             {
                    //             value: "tree",
                    //             label: "Tree 树形控件",
                    //             },
                    //             {
                    //             value: "pagination",
                    //             label: "Pagination 分页",
                    //             },
                    //             {
                    //             value: "badge",
                    //             label: "Badge 标记",
                    //             },
                    //         ],
                    //         },
                    //         {
                    //         value: "notice",
                    //         label: "Notice",
                    //         children: [
                    //             {
                    //             value: "alert",
                    //             label: "Alert 警告",
                    //             },
                    //             {
                    //             value: "loading",
                    //             label: "Loading 加载",
                    //             },
                    //             {
                    //             value: "message",
                    //             label: "Message 消息提示",
                    //             },
                    //             {
                    //             value: "message-box",
                    //             label: "MessageBox 弹框",
                    //             },
                    //             {
                    //             value: "notification",
                    //             label: "Notification 通知",
                    //             },
                    //         ],
                    //         },
                    //         {
                    //         value: "navigation",
                    //         label: "Navigation",
                    //         children: [
                    //             {
                    //             value: "menu",
                    //             label: "NavMenu 导航菜单",
                    //             },
                    //             {
                    //             value: "tabs",
                    //             label: "Tabs 标签页",
                    //             },
                    //             {
                    //             value: "breadcrumb",
                    //             label: "Breadcrumb 面包屑",
                    //             },
                    //             {
                    //             value: "dropdown",
                    //             label: "Dropdown 下拉菜单",
                    //             },
                    //             {
                    //             value: "steps",
                    //             label: "Steps 步骤条",
                    //             },
                    //         ],
                    //         },
                    //         {
                    //         value: "others",
                    //         label: "Others",
                    //         children: [
                    //             {
                    //             value: "dialog",
                    //             label: "Dialog 对话框",
                    //             },
                    //             {
                    //             value: "tooltip",
                    //             label: "Tooltip 文字提示",
                    //             },
                    //             {
                    //             value: "popover",
                    //             label: "Popover 弹出框",
                    //             },
                    //             {
                    //             value: "card",
                    //             label: "Card 卡片",
                    //             },
                    //             {
                    //             value: "carousel",
                    //             label: "Carousel 走马灯",
                    //             },
                    //             {
                    //             value: "collapse",
                    //             label: "Collapse 折叠面板",
                    //             },
                    //         ],
                    //         },
                    //     ],
                    // },
                    // {
                    //     value: "ziyuan",
                    //     label: "资源",
                    //     children: [
                    //         {
                    //             value: "axure",
                    //             label: "Axure Components",
                    //         },
                    //         {
                    //             value: "sketch",
                    //             label: "Sketch Templates",
                    //         },
                    //         {
                    //             value: "jiaohu",
                    //             label: "组件交互文档",
                    //         },
                    //     ],
                    // },
                ],
            }
        },
        created(){
            // document.getElementById('meros-view').style.display = 'none'
            this.changeTime(this.current)

            console.log('parentMenuItem', this.parentMenuItem)
        },
        methods: {
            handleChange(a,b){
                console.log(a,b)
            },
            changeArea(value, newValue){
                localStorage.setItem('areaValue', value)
                this.optionsValue = value
                // window.PubSub.publish(MerosTopic.FYEARTH_DATA, {
                //     menuItem: newValue
                // })
            },
            changeTime(index){
                localStorage.setItem('event-time', index)
                this.current = index
            },
            moreData(){
                document.getElementById('historyTitle').style.display = 'block'
                document.getElementById('header').style.display = 'none'
                document.getElementById('sliderBox').style.display = 'none'
                document.getElementById('more').style.display = 'none'
                document.getElementById('mainBox').style.width = 'calc(100vw - 35px)'
                document.getElementById('mainBox').style.height = 'calc(100vh - 62px)'
                document.getElementById('main').style.height = '100vh'
            }
        }
    }
</script>
<style scoped></style>